import { Grid, MenuItem, Tooltip, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import PersonIcon from '@material-ui/icons/Person';
import { useGenericStyles } from 'common/genericStyles';
import MoreOptionsMenu from '../moreOptionsMenu';
import TrocarFuncaoDrawer from './trocarFuncaoDrawer';

interface AvatarMenuProps {
  name: string;
  description: string;
}

export const AvatarMenu: React.FC<AvatarMenuProps> = (props) => {
  const genericClasses = useGenericStyles();
  const [openTrocarFuncaoDrawer, setOpenTrocarFuncaoDrawer] = useState<boolean>(false);

  return (
    <>
      <Grid style={{ paddingRight: '35px' }} container justifyContent="flex-end">
        <Grid item>
          <Grid container justifyContent="flex-end">
            <Grid item container justifyContent="flex-end">
              <PersonIcon style={{ marginRight: '10px' }} />
              <Typography variant="body1" className={genericClasses.wrapTxt}>
                {props.name}
              </Typography>
            </Grid>
            <Grid item>
              <Tooltip title={props.description} aria-label={props.description}>
                <Typography variant="body1" color="textSecondary" className={genericClasses.wrapTxt}>
                  {props.description}
                </Typography>
              </Tooltip>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <MoreOptionsMenu>
            <MenuItem onClick={() => setOpenTrocarFuncaoDrawer(true)}>
              <PersonIcon fontSize="small" style={{ marginRight: '10px' }} />
              {'Trocar função'}
            </MenuItem>
          </MoreOptionsMenu>
        </Grid>
      </Grid>
      <TrocarFuncaoDrawer opened={openTrocarFuncaoDrawer} onClose={() => setOpenTrocarFuncaoDrawer(false)} />
    </>
  );
};
